import axios from '@/utils/axios'

import { pathOr, tap, propOr } from 'ramda'

import { NUMBER_ELEMENTS_PER_PAGE } from '@/constants/generic'

import {
  INSERT_ORGANIZATION,
  INSERT_ORGANIZATIONS,
  UPDATE_ORGANIZATION,
  DELETE_ORGANIZATION,
  SET_CURRENT_ORGANIZATION,
  RESET_ADMIN,
} from '../constants'

// initial state
const initialState = () => ({
  organizations: {},
  currentOrganization: {}
})

const state = initialState()

// getters
const getters = {
  adminOrganizationsSize (state) {
    const organizations = pathOr([], ['organizations', 'results'])(state)
    return organizations.length
  },
  getOrganizations (state) {
    return state.organizations.results
  },
  buildPagination (state) {
    const pageCounter = getters.adminOrganizationsSize(state)
    const numberPages = (state.organizations.count / NUMBER_ELEMENTS_PER_PAGE)
    return {
      pageCounter,
      total: state.organizations.count,
      next: state.organizations.next,
      previous: state.organizations.previous,
      numberPages: Math.floor(numberPages)
    }
  },
}

// actions
const actions = {
  async createOrganization ({ commit }, organization) {
    return axios.post('/v1/organizations/', organization)
      .then(tap(response => commit(INSERT_ORGANIZATION, response.data)))
      .then(response => response.data)
  },
  async getOrganizations({ commit, rootGetters }, params) {
    if(!rootGetters['user/isElsaAdmin']) {
      return
    }

    try {
      const response = await axios.get(`/v1/organizations/`, {params})
      commit(INSERT_ORGANIZATIONS, response.data)
    } catch (error) {
      error
    }
  },
  async updateOrganization ({ commit }, organization) {
    return axios.put(`/v1/organizations/${organization.id}/`, organization.organization)
      .then(tap(response => commit(UPDATE_ORGANIZATION, response.data)))
      .then(propOr({}, 'data'))
  },
  partialUpdateOrganization ({ commit }, organization) {
    return axios.patch(`/v1/organizations/${organization.id}/`, organization.organization)
      .then(tap(response => commit(UPDATE_ORGANIZATION, response.data)))
      .then(propOr({}, 'data'))
  },
  deleteOrganization ({ commit }, organizationId) {
    return axios.delete(`/v1/organizations/${organizationId}`)
      .then(() => commit(DELETE_ORGANIZATION, organizationId))
  },
  setCurrentOrganization ({ commit }, organization) {
    commit(SET_CURRENT_ORGANIZATION, organization)
  },
  getOrganizationDetail ({ commit }, organizationId) {
    return axios.get(`/v1/organizations/${organizationId}/`)
      .then(response => commit(SET_CURRENT_ORGANIZATION, response.data))
  },
  reset({ commit }) {
    return commit(RESET_ADMIN)
  }
}

// mutations
const mutations = {
  [INSERT_ORGANIZATION] (state, organization) {
    state.organizations.results = [...state.organizations.results, organization]
  },
  [INSERT_ORGANIZATIONS] (state, organizations) {
    state.organizations = organizations
  },
  [UPDATE_ORGANIZATION] (state, organization) {
    state.currentOrganization = organization
    const organizationsResults = pathOr([], ['results'])(state.organizations)
    const index = organizationsResults.findIndex(org => org.id === organization.id)
    if (index !== -1) {
      state.organizations.results.splice(index, 1, organization)
    }
  },
  [DELETE_ORGANIZATION] (state, organizationId) {
    const orgs = state.organizations
    const index = orgs.indexOf(orgs.find(org => org.id === organizationId))
    if (index >= 0) {
      orgs.splice(index, 1)
    }
  },
  [SET_CURRENT_ORGANIZATION] (state, organization) {
    state.currentOrganization = organization
  },
  [RESET_ADMIN](state) {
    Object.assign(state, initialState())
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
